"use client";

import { Footer } from "@marketing/shared/components/Footer";
import { usePathname } from "next/navigation";

export function ConditionalFooter() {
	const pathname = usePathname();
	const isAppRoute = pathname.startsWith("/app");

	// If it's an app route, don't show the footer
	if (isAppRoute) return null;

	return <Footer />;
}
